export const DOCUMENT_GROUPS = [
  {
    group: 'Identity Proof',
    docs: [
      'Aadhaar Card',
      'PAN Card',
      'Voter ID Card (EPIC)',
      'Passport',
      'Driving Licence',
      'CGHS / ECHS Card',
      'Central Govt. Employee ID Card',
      'State Govt. Employee ID Card',
      'Defense / Police ID Card',
      'Senior Citizen Card',
      'Student ID Card',
    ],
  },
  {
    group: 'Address Proof',
    docs: [
      'Ration Card',
      'Electricity Bill',
      'Water / Property Tax Receipt',
      'Gas / LPG Connection Book',
      'Telephone Bill (Landline)',
      'Bank Statement with Address',
      'Post Office Passbook',
      'Rent Agreement / Lease Agreement',
      'LIC Policy Document',
      'Property Registration Document',
      'Municipal / Panchayat Certificate',
    ],
  },
  {
    group: 'Birth & Age Proof',
    docs: [
      'Birth Certificate',
      '10th Marksheet (as Age Proof)',
      'Transfer Certificate (TC)',
      'Hospital Birth Record',
      'Baptism Certificate',
      'Panchayat / Municipal Birth Record',
    ],
  },
  {
    group: 'Education Documents',
    docs: [
      '5th Pass Certificate / Marksheet',
      '8th Pass Certificate / Marksheet (DMC)',
      '10th Pass Certificate / Marksheet (DMC)',
      '12th Pass Certificate / Marksheet (DMC)',
      'ITI National Trade Certificate (NTC)',
      'Diploma Certificate & Marksheet',
      'B.A. Degree & Marksheet',
      'B.Com Degree & Marksheet',
      'B.Sc Degree & Marksheet',
      'BCA Degree & Marksheet',
      'BBA Degree & Marksheet',
      'B.Tech / BE Degree & Marksheet',
      'B.Ed Degree & Marksheet',
      'LLB Degree & Marksheet',
      'MBBS Degree & Marksheet',
      'B.Pharma Degree & Marksheet',
      'GNM / ANM Nursing Certificate',
      'M.A. Degree & Marksheet',
      'M.Com Degree & Marksheet',
      'M.Sc Degree & Marksheet',
      'MCA Degree & Marksheet',
      'MBA Degree & Marksheet',
      'M.Tech / ME Degree & Marksheet',
      'LLM Degree & Marksheet',
      'MD / MS Degree & Marksheet',
      'Ph.D Certificate',
      'NET / SET Certificate',
      'Migration Certificate',
      'Character Certificate (School / College)',
    ],
  },
  {
    group: 'Caste / Category Certificates',
    docs: [
      'Caste Certificate – OBC (Central List)',
      'Caste Certificate – OBC (State List)',
      'Non-Creamy Layer Certificate (OBC)',
      'Caste Certificate – SC',
      'Caste Certificate – ST',
      'EWS (Economically Weaker Section) Certificate',
      'Disability Certificate (PwD – 40%+ Disability)',
      'UDID Card (Unique Disability Identity)',
      'Ex-Serviceman Discharge Book',
      'Dependent of Ex-Serviceman Certificate',
      'Minority Community Certificate',
      'Orphan Certificate',
      'Widow / Widower Certificate',
      'Single Girl Child Certificate',
      'Freedom Fighter Descendant Certificate',
    ],
  },
  {
    group: 'Income & Financial Documents',
    docs: [
      'Income Certificate (SDM / Tehsildar)',
      'BPL (Below Poverty Line) Card',
      'Income Tax Return (ITR)',
      'Form 16 (TDS Certificate)',
      'Salary Slip / Pay Slip',
      'Bank Statement (3 / 6 Months)',
      'Cancelled Cheque / Bank Account Details',
      'Kisan Credit Card',
      'PM Kisan Registration / Farmer ID',
    ],
  },
  {
    group: 'Land & Agriculture Documents',
    docs: [
      'Khatauni / Khasra (Land Record)',
      'Jamabandi (Revenue Record)',
      'Sale Deed / Registry',
      'Property Tax Receipt',
      'Farmer / Agriculture Land Certificate',
      'Crop Insurance Policy (PMFBY)',
      'Seed / Fertilizer License',
      'Irrigation Certificate',
    ],
  },
  {
    group: 'Health & Medical Documents',
    docs: [
      'Ayushman Bharat / PM-JAY Golden Card',
      'Health Insurance Policy',
      'Medical Fitness Certificate',
      'Disability Medical Certificate (Medical Board)',
      'COVID-19 Vaccination Certificate',
      'Blood Group Certificate',
      'Hospital Discharge Summary',
    ],
  },
  {
    group: 'Employment & Service Documents',
    docs: [
      'Employment / Service Certificate',
      'Experience Certificate',
      'Appointment Letter',
      'NOC from Employer',
      'Relieving Letter',
      'Pension Payment Order (PPO)',
      'Ex-Serviceman PPO / Pension Book',
    ],
  },
  {
    group: 'Family & Civil Documents',
    docs: [
      'Marriage Certificate / Registration',
      'Divorce Decree / Certificate',
      'Death Certificate',
      'Legal Heir Certificate',
      'Succession Certificate',
      'Adoption Certificate / Court Order',
      'Dependency Certificate',
      'Family Identity Proof (Ration Card / Family Register)',
    ],
  },
  {
    group: 'Domicile & Residence',
    docs: [
      'Domicile Certificate',
      'Residence / Nativity Certificate',
      'Bonafide Resident Certificate (Panchayat / SDM)',
      'Local Body Certificate',
    ],
  },
  {
    group: 'Vehicle Documents',
    docs: [
      'Vehicle Registration Certificate (RC)',
      'Vehicle Insurance Policy',
      'Pollution Under Control (PUC) Certificate',
      'Fitness Certificate (Commercial Vehicles)',
    ],
  },
  {
    group: 'Business & Professional Documents',
    docs: [
      'GST Registration Certificate',
      'MSME / Udyam Registration Certificate',
      'Shop & Establishment License',
      'Trade License',
      'Professional Tax Certificate',
      'CA Certificate',
      'Bar Council Enrollment Certificate',
      'Medical Council Registration Certificate',
    ],
  },
  {
    group: 'Sports, NCC & Achievement',
    docs: [
      'Sports Certificate (State / National Level)',
      'NCC Certificate (A / B / C)',
      'NSS Participation Certificate',
      'Scout & Guide Certificate',
      'Meritorious Achievement Certificate',
    ],
  },
  {
    group: 'Affidavit & Declaration',
    docs: [
      'Self-Declaration Affidavit',
      'Character Certificate (Police / Gazette Officer)',
      'NOC (No Objection Certificate)',
      'Notarized Document',
      'e-Stamp Paper',
    ],
  },
  {
    group: 'Photographs & Biometric',
    docs: [
      'Passport Size Photographs (Colour, White Background)',
      'Signature (Scanned / Original)',
      'Thumb Impression',
    ],
  },
];

export const ALL_DOCUMENTS = DOCUMENT_GROUPS.flatMap((g) => g.docs);
